import React, { Component, PropTypes } from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';
import HjblcxTable from './hjblcxTable';

const baseUrlPath = "/tjcx/hjblcx"; //基础路径


/**
 * hjblcx列表
 * @author Xiafanglin
 * @date 2018-03-20 09:56:14
 * Version: 1.0
 */
export default class HjblcxTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns:[],
        }
    }
    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                search: 'input',
                width: '120px',
                searchType:"input"
            }, {
                title: '考生号',
                dataIndex: 'KSH',
                search: 'input',
                width: '150px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                search: 'input',
                width: '90px',
                search:'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            },{
                title: '校区',
                width: '200px',
                dataIndex: 'XQMC',
                searchType:"select"
            },{
                title: '院系',
                width: '200px',
                search: 'input',
                dataIndex: 'BMMC',
                searchType:"select"
            },{
                title: '专业',
                width: '200px',
                search: 'input',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            },{
                title: '班级',
                width: '200px',
                search: 'input',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            },{
                title: '现场报道状态',
                width: '200px',
                search: 'select',
                dataIndex: 'XCBDZT',
                searchType:"select",
            }
        ];
        this.setState({
            selectKey: this.props.selectKey,
            columns:columnConst,
        },() => {
            this.getColumn(this.state.selectKey);
        });
    }
    //获取动态字段
    getColumn = (lcdyid) => {
        if (lcdyid) {
            NHFetch(baseUrlPath+"/getHjdyData","get","lcid="+lcdyid).then(
                res => {
                    if (res.data) {
                        let columnLet = this.state.columns;
                        res.data.map((item) => {
                            let column = {
                                title: item.HJMC,
                                width: '200px',
                                search: 'input',
                                filters: [{ text: '已办理', value: '已办理' }, { text: '未办理', value: '未办理' }],
                                dataIndex: "a"+item.BZ,
                            };
                            columnLet.push(column);
                        });
                        this.setState({
                            columns: columnLet
                        });
                    }
                }
            )
        }

    }

    //导出Excel文件  
    handleExportBtnClick = () => {
        this.refs.nhTable.exportExcel("环节办理情况");
    };
    

    render() {
        return(
            <div className={css.main_right_content} style={{height:getSize().windowH-230}}>
                <div className={css.table} >
                    <HjblcxTable ref='nhTable'
                             rowKey={record =>record.XH} //TODO 把此处的信息改成自己的
                             columns={this.state.columns}
                             sign={this.props.selectKey}
                             initParams={this.props.initParams}
                             rangeFilter={true}
                    >
                    <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleExportBtnClick}>导出</Button>
                    </HjblcxTable>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/hjblcx/hjblcxTab.js